export default __webpack_public_path__ + "static/media/banner-healthcare-mobile-comp.b94b7f71.jpg";